export enum ChartSerieTypeEnum {
  Line = 'line',
  Bar = 'bar',
  Scatter = 'scatter',
  EffectScatter = 'effectScatter',
}

export enum ChartLineTypeEnum {
  Solid = 'solid',
  Dotted = 'dotted',
}
